<template>
    <v-data-table
        :options.sync= "pagination"
        :headers="headers"
        :items="items"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat color="white">
                <v-toolbar-title>{{auditViewTitle}}</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
               </v-toolbar>
            </template>
            <template v-slot:item="props">
                <tr>                    
                    <td class="row_class">{{props.item.access_at}}</td>
                    <td class="row_class">{{props.item.lastname}}</td>
                    <td class="row_class">{{props.item.firstname}}</td>
                    <td class="row_class">{{props.item.email}}</td>
                    <td class="row_class">{{props.item.app}}</td>
                    <td class="row_class" v-if="filterStatus=='document_audit'">{{props.item.document}}</td>
                </tr>
            </template>
    </v-data-table>
</template>
<script>
import Audits from '@/api/audits'

export default {
    name: 'AuditAdmin',    
    props: {
            filterStatus: {
                type: String,
                required: true
            }
        },
    data: () => ({
        totalItems: 0,
        loading:false,
        items: [],
        pagination: {},
        totalItems:0,
        requestList:{
            'pageNumber':1,
            'pageSize':10,
            'search':''
        },
        headers_users: [
            { text: 'Datetime', value: 'created_at', sortable:false  },
            { text: 'Lastname', value: 'lastname', sortable:false  },
            { text: 'Firstname', value: 'firstname', sortable:false },
            { text: 'Email', value: 'email', sortable:false  },
            { text: 'App', value: 'app', sortable:false  },
        ],
        headers_documents: [
            { text: 'Datetime', value: 'created_at', sortable:false  },
            { text: 'Lastname', value: 'lastname', sortable:false  },
            { text: 'Firstname', value: 'firstname', sortable:false },
            { text: 'Email', value: 'email', sortable:false  },
            { text: 'App', value: 'app', sortable:false  },
            { text: 'Document', value: 'document', sortable:false  },
        ]
    }),
    computed: {
        auditViewTitle(){
            var title = ''
            switch(this.filterStatus){
                case 'user_audit':             
                    title = 'User Login Audit'
                    break
                case 'document_audit':
                    title = 'Document Login Audit'
                    break
            }
            return title
        },
        headers(){
            var header = ''
            switch(this.filterStatus){
                case 'user_audit':             
                    header = this.headers_users
                    break
                case 'document_audit':
                    header = this.headers_documents
                    break
            }
            return header
        }
    },
    watch: {
        pagination: {
            handler () {                
               this.getAudits()
               .then(data => {
                    this.items = data.items
                    this.totalItems = data.total
               })
            },
            deep: true
        },
        filterStatus(val){                           
            this.getAudits()
               .then(data => {
                    this.items = data.items
                    this.totalItems = data.total
               })
        }
    },
    created(){
        this.pagination
    },
    methods: {
        getAudits () {
            let localThis = this
            this.loading = true
            let items =[]
            localThis.requestList.pageSize = this.pagination.itemsPerPage
            localThis.requestList.pageNumber = this.pagination.page
            switch(this.filterStatus){
                case 'user_audit':
                    return new Promise((resolve, reject) => {
                        Audits.getUserAudits(localThis.requestList).then(
                            data => {
                                items = data.results
                                const total = data.totalItems                        
                                setTimeout(() => {
                                    localThis.loading = false;
                                    resolve({
                                        items,
                                        total
                                    })
                                    }, 1000
                                )
                            }
                        )                
                    })
                    break
                case 'document_audit':
                    return new Promise((resolve, reject) => {
                        Audits.getDocumentAudit(localThis.requestList).then(
                            data => {
                                items = data.results
                                const total = data.totalItems                        
                                setTimeout(() => {
                                    localThis.loading = false;
                                    resolve({
                                        items,
                                        total
                                    })
                                    }, 1000
                                )
                            }
                        )                
                    })
                    break
            }
            
        }
    }
}
</script>
<style scoped>
    .menu_items{
        font-size: smaller !important ;
    }
    .title{
        font-size: medium !important;
        color: #003498 !important;
    }
    .v-btn{
        text-transform: none !important;
    }
    .row_class{
        height: 19px !important;
        font-size: small !important;
    }
    .v-chip.v-size--default {
    border-radius: 16px;
    font-size: 12px;
    height: 22px;
}
</style>